export interface SepaRejectResponseType {
  reasonCode?: string;
}

export interface SepaSuccessResponseType {
  hostedPageId: string;
  mandateId: string;
  bankAccountId: string;
  customerId: string;
  merchantId: string;
  connectorId: string;
  reference: string;
  approvalDate: string;
}

export enum ErrorCode {
  TIMEOUT = 'timeout',
  VERIFICATION = 'verification',
  BANKCONNECTION = 'bankConnection',
  NO_ERROR = '',
}
